import { Store } from 'vuex';
import createPersistedState, { Storage } from 'vuex-persistedstate';
import ISerializedBetSlip from '@core/models/lottoBetSlip/serialization/ISerializedBetSlip';

const BETSLIP_STORAGE_KEY = 'lottoBetSlip';

export default (store: Store<any>) => createPersistedState({
    key: BETSLIP_STORAGE_KEY,
    filter: (mutation: any) => isBetSlipMutation(mutation.type),
    reducer: (state: any) => serializeBetSlip(state),
    getState: async (key: string, storage: Storage) => {
        try {
            const betSlip = JSON.parse(storage.getItem(key) as any);
            const unsubscribe = store.subscribeAction(async (action: any) => {
                if (action.type === 'data/country/setIsAppReady' && action.payload === true) {
                    await store.dispatch('ui/lotto/betSlip/deserializeBetSlip', betSlip);
                    unsubscribe();
                }
            });
            return;
        } catch (e) {
            store.dispatch('errors/showError', e, { root: true });
        }
    }
})(store);

const BET_SLIP_REGEX = /^ui\/lotto\/betSlip\/*/;

const isBetSlipMutation = (mutationType: string): boolean =>
    BET_SLIP_REGEX.test(mutationType);

const serializeBetSlip = (state: any) => {
    const { selections,
        selectedSystems,
        stake,
        maxSystems,
        maxSelections,
        purchaseType,
        event
    } = state.ui.lotto.betSlip;
    return {
        selections,
        selectedSystems,
        stake,
        maxSystems,
        maxSelections,
        purchaseType,
        event
    } as ISerializedBetSlip;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/persistence/lottoBetSlipPersist.ts